import "./index.scss"
import {
    ConfigProvider,
    Segmented,
    Button,
    Form,
    Table,
    message,
    Upload,
    Col,
    Row,
    Space,
    DatePicker,
    Spin,
    Divider,
    Pagination,
    Input, Select, Modal
} from 'antd';
import zh_TW from 'antd/locale/zh_TW';
import 'dayjs/locale/zh-tw';

import {useEffect, useRef, useState} from "react";
import {BASE_URL} from "../../api/config";
import request from "../../api/request";
import axios, {options} from "axios";
import dayjs from "dayjs";
// 警報訊息中文化核心解析器
const translateAlarmMessage = (msg) => {
    if (!msg) return "";

    // 1. 優先處理包含特定的感測器類型（如 pH, ORP, EC）
    if (msg.includes("pH Type=")) return "pH值過高";
    if (msg.includes("ORP Type=")) return "氧化還原電位(ORP)異常";
    if (msg.includes("EC Type=") || msg.includes("Type=220")) return "導電度過高";
    
    // 2. 處理狀態與通訊錯誤
    if (msg.includes("Communication error")) return "設備通訊中斷";
    if (msg.includes("Battery Low")) return "設備電量過低";
    if (msg.includes("超出警報值")) return "AI影像監測異常";

    // 保險退路：如果都不符合，回傳原始訊息
    return msg;
};
const Alert = () => {

    useEffect(() => {
        getList();
    }, []);

    const { RangePicker } = DatePicker;

    const [list,setList] = useState([])
    const [spinning, setSpinning] = useState(false)
    const [rank, setRank] = useState('');

    const columns = [
        {
            title: '編號',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 70
        },
        {
            title: '地點',
            dataIndex: 'log_id',
            key: 'log_id',
            align: 'center',
            width: 200,
            render: (text) => (
                <div style={{ 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap'
                }}>
                    {text}
                </div>
            )
        },
        {
            title: '開始時間',
            dataIndex: 'start',
            key: 'start',
            align: 'center',
            width: 180,
            render: (start) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {dayjs(start).format('YYYY-MM-DD HH:mm:ss')}
                </div>
            )
        },
        
        {
            title: '確認時間',
            dataIndex: 'end',
            key: 'end',
            align: 'center',
            width: 180,
            render: (end) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {end ? dayjs(end).format('YYYY-MM-DD HH:mm:ss') : '-'}
                </div>
            )
        },
        {
            title: '警報等級',
            dataIndex: 'rank',
            key: 'rank',
            align: 'center',
            width: 100,
            render: (text) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {text}
                </div>
            )
        },
        {
            title: '警報設定值',
            dataIndex: 'set_value',
            key: 'set_value',
            align: 'center',
            width: 120,
            render: (value, record) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {record.log_id === "柴頭港溪截流站-閘門口" 
                        ? value
                        : parseFloat(value).toFixed(3)
                    }
                </div>
            )
        },
        {
            title: '過程值',
            dataIndex: 'alarm_value',
            key: 'alarm_value',
            align: 'center',
            width: 80,
            render: (value, record) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {record.log_id === "柴頭港溪截流站-閘門口" 
                        ? `${(value * 100).toFixed(0)}%`
                        : value.toFixed(3)
                    }
                </div>
            )
        },
        {
            title: '警報訊息',
            dataIndex: 'message',
            key: 'message',
            align: 'center',
            width: 200,
            render: (text) => (
                <div style={{ 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap'
                }}>
                    {translateAlarmMessage(text)}
                </div>
            )
        },
        {
            title: '狀態',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 80,
            render: (status, record) => (
                <Button
                    className={`status-button ${status === 0 ? 'unresolved' : 'resolved'}`}
                    onClick={() => status === 0 && clearAlarm(record.id, record)}
                    disabled={status === 1}
                >
                    {status === 0 ? '未消除' : '已消除'}
                </Button>
            )
        }
    ];

    const page = useRef(1)
    const size = useRef(10)
    // const log_id = useRef('')
    const [log_id, setLog_id] = useState('')
    const [status, setStatus] = useState('')
    const [time_sort, setTime_sort] = useState(1)
    // const [startRage, setStartRage] = useState('')
    const startRage =useRef(dayjs().startOf('month').format('YYYY-MM-DD'))
    const endRage =useRef(dayjs().format('YYYY-MM-DD'))

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const handleTableChange = (newPagination) => {
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize
        }));
        
        getList({
            page_num: newPagination.current,
            page_size: newPagination.pageSize,
            status,
            log_id,
            rank,
            time_sort,
            startRage: startRage.current,
            endRage: endRage.current
        });
    };

    const getList = (params) => {
        setSpinning(true);
        request.post(BASE_URL + '/water/get_alarm_data', params || {
            page_num: pagination.current,
            page_size: pagination.pageSize,
            status,
            log_id,
            rank,
            time_sort,
            startRage: startRage.current,
            endRage: endRage.current
        }).then(res => {
            if(res.code === 200){
                setSpinning(false);
                const rows = Array.isArray(res.data.rows) ? res.data.rows : [];
                setList(rows);
                
                setPagination(prev => ({
                    ...prev,
                    total: res.data.total || 0,
                    current: Math.max(1, Math.min(prev.current, Math.ceil(res.data.total / pagination.pageSize)))
                }));
            }
        }).catch(err => {
            console.error('獲取警報列表失敗：', err);
            setSpinning(false);
            message.error('獲取警報列表失敗');
        });
    };
    const [keyword, setKeyword] = useState()
    const changeKeyword = (e) => {
        setKeyword(e.target.value)
        // keyword.value = e.target.value
    }

    const options = [
        { value: '', label: '全部' },
        { value: 'PA管網', label: 'PA管網' },
        { value: 'PB管網', label: 'PB管網' },
        { value: '廠內進流點', label: '廠內進流點' },
        { value: '柴頭港溪截流站', label: '柴頭港溪截流站' },
//        { value: '柴頭港溪截流站-閘門口', label: '柴頭港溪截流站-閘門口' },
    ];
    const sortOptions = [
        { value: 1, label: '最新到舊' },
        { value: 2, label: '最舊到新' },
    ];

    const stateOptions = [
        { value: '', label: '全部' },
        { value: '0', label: '未消除' },
        { value: '1', label: '已消除' },
    ];

    const rankOptions = [
        { value: '', label: '全部' },
        { value: 'Warning', label: '警告 (Warning)' },
        { value: 'Alert', label: '警示 (Alert)' },
        { value: 'Dangerous', label: '危險 (Dangerous)' },
        { value: 'Emergency', label: '緊急 (Emergency)' }
    ];

    const setDateRange = (e) => {
        if (!e) {
            // 當清除日期時，設置為當月初到當天
            startRage.current = dayjs().startOf('month').format('YYYY-MM-DD');
            endRage.current = dayjs().format('YYYY-MM-DD');
            return;
        }

        if (e[0]) {
            startRage.current = dayjs(e[0]).format('YYYY-MM-DD');
        }
        if (e[1]) {
            endRage.current = dayjs(e[1]).format('YYYY-MM-DD');
        }
    };
    const handleSearch = (e) => {
        // 在搜尋時重置頁碼到第一頁
        setPagination(prev => ({
            ...prev,
            current: 1
        }));
        
        // 使用重置後的頁碼進行查詢
        getList({
            page_num: 1,  // 強制使用第一頁
            page_size: pagination.pageSize,
            status,
            log_id,
            rank,
            time_sort,
            startRage: startRage.current,
            endRage: endRage.current
        });
    }

    const exportLogs = async () => {
        setSpinning(true);
        try {
            const response = await axios({
                url: BASE_URL + `/water/alarm_data_to_cvs`,
                method: 'POST',
                responseType: 'blob',
                data: {
                    log_id: log_id,
                    status: status,
                    rank: rank,
                    time_sort: time_sort,
                    start_time: startRage.current,
                    end_time: endRage.current,
                    page_num: pagination.current,
                    page_size: pagination.pageSize
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/csv; charset=utf-8'
                }
            });
            
            const contentDisposition = response.headers['content-disposition'];
            let filename = `警報紀錄_${dayjs().format('YYYYMMDD_HHmmss')}.csv`;
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match && match[1]) {
                    filename = decodeURIComponent(match[1]);
                }
            }

            const blob = new Blob(
                [new Uint8Array([0xEF, 0xBB, 0xBF]), response.data], 
                { type: 'text/csv; charset=utf-8' }
            );
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setSpinning(false);

        } catch (error) {
            setSpinning(false);
            console.error('檔案下載失敗：', error);
            message.error(error.response?.data?.message || '檔案下載失敗');
        }
    };

    const clearAlarm = async (id, record) => {
        Modal.confirm({
            title: '確認消除警報',
            content: (
                <div style={{ 
                    marginLeft: '-35px',
                    width: 'calc(100% + 35px)'
                }}>
                    <div style={{ 
                        margin: '15px 0', 
                        padding: '20px 20px',
                        backgroundColor: '#f0f0f0', 
                        borderRadius: '4px',
                        lineHeight: '2'
                    }}>
                        <p style={{ margin: '0' }}><strong>地點：</strong>{record.log_id}</p>
                        <p style={{ margin: '0' }}><strong>開始時間：</strong>{dayjs(record.start).format('YYYY-MM-DD HH:mm:ss')}</p>
                        <p style={{ margin: '0' }}>
                            <strong>警報設定值：</strong>
                            {record.rank} / {
                                record.log_id === "柴頭港溪截流站-閘門口" 
                                    ? record.set_value
                                    : parseFloat(record.set_value).toFixed(3)
                            }
                        </p>
                        <p style={{ margin: '0' }}><strong>警報訊息：</strong>
                            {record.log_id === "柴頭港溪截流站-閘門口" 
                                ? `${(record.alarm_value * 100).toFixed(0)}%`
                                : record.alarm_value.toFixed(3)
                            }，{translateAlarmMessage(record.message)}
                        </p>
                    </div>
                </div>
            ),
            okText: '確認消除',
            cancelText: '取消',
            width: 500,
            onOk: async () => {
                try {
                    setSpinning(true);
                    await request.post(BASE_URL + '/water/alarm/delete', {id});
                    message.success('警報已確認');
                    getList();
                } catch (error) {
                    console.error('Failed to confirm alarm:', error);
                    message.error('確認警報失敗');
                } finally {
                    setSpinning(false);
                }
            }
        });
    };

    return (
        <div className="index" style={{color: '#fff',padding: "20px"}}>
            <Spin 
                spinning={spinning} 
                tip={<div style={{ color: '#fff', marginTop: '35px' }}>載入中</div>}
                percent="auto" 
                fullscreen 
            />
            <div className="analyse-kaiv2" style={{display: 'flex',justifyContent: "center"}}>
                <div className="analyse-box">
                    <div className="name">警報紀錄</div>
                    <div className="opt-box">
                        <div className="search">
                            <Form onFinish={handleSearch} layout="inline" style={{width: '100%'}}>

                                <Form.Item className="label" label="地點">
                                    <Select
                                        value={log_id}
                                        onChange={setLog_id}
                                        style={{ width: '100%', marginRight: 8 }}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 'max-content' }}
                                    >
                                        {options.map(option => (
                                            <Select.Option key={option.value} value={option.value} style={{width: '100%'}}>
                                                {option.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item label="警報等級">
                                    <Select
                                        value={rank}
                                        onChange={setRank}
                                        style={{ width: '100%', marginRight: 8 }}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 'max-content' }}
                                    >
                                        {rankOptions.map(option => (
                                            <Select.Option key={option.value} value={option.value} style={{width: '100%'}}>
                                                {option.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item  label="狀態">
                                    <Select
                                        value={status}
                                        onChange={setStatus}
                                        style={{ width: '100%', marginRight: 8 }}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 'max-content' }}
                                    >
                                        {stateOptions.map(option => (
                                            <Select.Option key={option.value} value={option.value} style={{width: '100%'}}>
                                                {option.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>


                                <Form.Item  name="dateRange" label="開始日期">
                                    <ConfigProvider locale={zh_TW}>
                                        <RangePicker  defaultValue={[dayjs().startOf("month"), dayjs()]} onChange={(dateRange) => setDateRange(dateRange)}/>
                                    </ConfigProvider>
                                </Form.Item>

                                <Form.Item label="排序">
                                    <Select
                                        value={time_sort}
                                        onChange={setTime_sort}
                                        style={{ width: '100%', marginRight: 8 }}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 'max-content' }}
                                    >
                                        {sortOptions.map(option => (
                                            <Select.Option key={option.value} value={option.value} style={{width: '100%'}}>
                                                {option.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType="submit">搜尋</Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button 
                                        type="primary" 
                                        onClick={exportLogs}
                                        disabled={!list.length}
                                        style={{ display: list.length ? 'inline-block' : 'none' }}
                                    >
                                        導出
                                    </Button>
                                </Form.Item>

                            </Form>
                        </div>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorBgContainer: "#002b56",
                                    colorText: "#FFF",
                                },
                                components: {
                                    Table: {
                                        /* 这里是你的组件 token */
                                        headerBg: "#002b56",
                                        headerColor: "#FFF",
                                        footerColor: "#FFF",
                                        footerBg: "#002b56"
                                    }
                                },
                            }}
                        >
                            <Table
                                rowKey="id"
                                bordered
                                dataSource={list}
                                columns={columns}
                                pagination={pagination}
                                onChange={handleTableChange}
                            />
                        </ConfigProvider>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default Alert;
